
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"en":{"button.title":"Settings","hierarchy.description":"Hierarchy","virtualValuesColumnLabel":"Measures (summarized)"},"de":{"button.title":"Einstellungen","hierarchy.description":"Hierarchie","virtualValuesColumnLabel":"Werte (zusammengefasst)"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();